import { render, staticRenderFns } from "./AdminGuideCards.vue?vue&type=template&id=4d6871c7&scoped=true&"
import script from "./AdminGuideCards.vue?vue&type=script&lang=ts&"
export * from "./AdminGuideCards.vue?vue&type=script&lang=ts&"
import style0 from "./AdminGuideCards.vue?vue&type=style&index=0&id=4d6871c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6871c7",
  null
  
)

export default component.exports